<template>
  <div>
    <ListRegionais
      :subjectPermission="subjectPermission"
    />
  </div>
</template>

<script>
import ListRegionais from "./../../lists/ListRegionais";

export default {
  components: {
    ListRegionais,
  },
  data() {
    return {
      subjectPermission: "Corretora",
    };
  },
  methods: {},
};
</script>
